import { ACTIVITY_GTM_EVENT, GTM_EVENT } from '../constants/gtm'

type TGetEventNameByPlatformRecommendEducationFn = (
  isWebview: boolean,
) => string

export const getEducationNoticeImpressionByPlatform: TGetEventNameByPlatformRecommendEducationFn =
  (isWebview) => {
    if (isWebview) {
      return ACTIVITY_GTM_EVENT.EDUCATION_NOTICE.APP.IMPRESSION_EVENT
    }
    return ACTIVITY_GTM_EVENT.EDUCATION_NOTICE.MOBILE.IMPRESSION_EVENT
  }

export const getEducationTopPinnedBannerImpressionByPlatform: TGetEventNameByPlatformRecommendEducationFn =
  (isWebview) => {
    if (isWebview) {
      return GTM_EVENT.EDUCATION_TOP_PINNED_BANNER.APP!.IMPRESSION_EVENT
    }
    return GTM_EVENT.EDUCATION_TOP_PINNED_BANNER.MOBILE!.IMPRESSION_EVENT
  }

export const getEducationNoticeClickByPlatform: TGetEventNameByPlatformRecommendEducationFn =
  (isWebview) => {
    if (isWebview) {
      return ACTIVITY_GTM_EVENT.EDUCATION_NOTICE.APP.CLICK_EVENT
    }
    return ACTIVITY_GTM_EVENT.EDUCATION_NOTICE.MOBILE.CLICK_EVENT
  }

export const getEducationTopPinnedBannerClickByPlatform: TGetEventNameByPlatformRecommendEducationFn =
  (isWebview) => {
    if (isWebview) {
      return GTM_EVENT.EDUCATION_TOP_PINNED_BANNER.APP!.CLICK_EVENT
    }
    return GTM_EVENT.EDUCATION_TOP_PINNED_BANNER.MOBILE!.CLICK_EVENT
  }
3
type TGetQnaBannerImpressionByPlatformFn = (
  isWebview: boolean,
) => string | undefined
export const getQnaBannerImpressionByPlatform: TGetQnaBannerImpressionByPlatformFn =
  (isWebview) => {
    return isWebview
      ? GTM_EVENT.RECRUIT_QNA_BOTTOM.APP?.IMPRESSION_EVENT
      : GTM_EVENT.RECRUIT_QNA_BOTTOM.MOBILE?.IMPRESSION_EVENT
  }

type TGetQnaBannerClickByPlatformFn = (isWebview: boolean) => string | undefined
export const getQnaBannerClickByPlatform: TGetQnaBannerClickByPlatformFn = (
  isWebview,
) => {
  return isWebview
    ? GTM_EVENT.RECRUIT_QNA_BOTTOM.APP?.CLICK_EVENT
    : GTM_EVENT.RECRUIT_QNA_BOTTOM.MOBILE?.CLICK_EVENT
}

type TGetCoverLetterSearchEventByPlatformFn = (isWebview: boolean) => string

export const getCoverLetterSearchImpressionByPlatform: TGetCoverLetterSearchEventByPlatformFn =
  (isWebview) => {
    if (isWebview) {
      return GTM_EVENT.COVER_LETTER_SEARCH.APP?.IMPRESSION_EVENT || ''
    }
    return GTM_EVENT.COVER_LETTER_SEARCH.MOBILE?.IMPRESSION_EVENT || ''
  }

export const getCoverLetterSearchClickByPlatform: TGetCoverLetterSearchEventByPlatformFn =
  (isWebview) => {
    if (isWebview) {
      return GTM_EVENT.COVER_LETTER_SEARCH.APP?.CLICK_EVENT || ''
    }
    return GTM_EVENT.COVER_LETTER_SEARCH.MOBILE?.CLICK_EVENT || ''
  }
